<div>
  <mat-card>
    <mat-card-header>
      <mat-card-title>
        <div class="copy-container" (click)="copyOverview()">
          <span>{{ 'COMMON.OVERVIEW' | translate }}</span>
          <mat-icon class="copy-icon">content_copy</mat-icon>
        </div>
      </mat-card-title>
    </mat-card-header>
    <mat-card-content>
      {{ conversation()?.summary }}
    </mat-card-content>
  </mat-card>
  <mat-card>
    <mat-card-header>
      <mat-card-title>
        <div class="copy-container" (click)="copyActionItems()">
          <span>{{ 'COMMON.ACTION_ITEMS' | translate }}</span>
          <mat-icon class="copy-icon">content_copy</mat-icon>
        </div>
      </mat-card-title>
    </mat-card-header>
    <mat-card-content>
      @if (actionItemsByOwner().size > 0) {
        @for (entry of actionItemsByOwner() | keyvalue; track entry.key) {
          <div class="copy-container" (click)="copyActionItem(entry)">
            <meeting-analysis-participant
              [name]="entry.key"
              [linkToContactPage]="false"
              [shape]="'square'"
            ></meeting-analysis-participant>
            <mat-icon class="copy-icon">content_copy</mat-icon>
          </div>
          <ul>
            @for (item of entry.value; track item) {
              <li>{{ item.item }}</li>
            }
          </ul>
        }
      } @else {
        <div class="empty-state">{{ 'COMMON.NONE_FOUND' | translate }}</div>
      }
    </mat-card-content>
  </mat-card>
  <mat-card>
    <mat-card-header>
      <mat-card-title>
        <div class="copy-container" (click)="copyTopics()">
          <span>{{ 'COMMON.TOPICS' | translate }}</span>
          <mat-icon class="copy-icon">content_copy</mat-icon>
        </div>
      </mat-card-title>
    </mat-card-header>
    <mat-card-content>
      @if ((conversation()?.topicsDiscussed || []).length > 0) {
        <mat-accordion multi>
          @for (topic of conversation()?.topicsDiscussed || []; track topic.topic) {
            <div class="copy-container" (click)="copyTopic(topic)">
              <span class="title">{{ topic.topic }}</span>
              <span class="duration">{{ getDuration(topic.topicDuration) }}</span>
              <mat-icon class="copy-icon">content_copy</mat-icon>
            </div>
            <ul>
              @for (keyTakeaway of topic.keyTakeaways; track keyTakeaway.keyTakeaway) {
                <li
                  meeting-analysis-video-jump
                  [text]="keyTakeaway.keyTakeaway || ''"
                  [duration]="keyTakeaway.timestamp || 0"
                  (jumpToTimestamp)="clickedTimestamp($event)"
                ></li>
              }
            </ul>
          }
        </mat-accordion>
      } @else {
        <div class="empty-state">{{ 'COMMON.NONE_FOUND' | translate }}</div>
      }
    </mat-card-content>
  </mat-card>
</div>
